import {Service} from "@/services/superclasses/service";

const api = window.contextPath + '/rest/newsletter-dates';

export class NewsletterDateService extends Service {

    public search = async (args: {
        host: number,
        from?: Date,
        to?: Date
    }): Promise<Date[]> => {
        return this.data(await this.get<Date[]>(api,
            {
                params: args
            }))
    }
}

export const newsletterDateService = new NewsletterDateService()